export const truncate = (str: string, limit: number = 10) => {
  if (!str) str = '';
  if (typeof str !== 'string') {
    throw new Error('Invalid type passed. Expected a string!');
  }

  return `${str.substring(0, limit)}${limit <= str.length ? '...' : '' }`
}